// routes which require authentication
const authRoutesAwards = [
  {
    path: '/awards',
    name: 'Awards',
    meta: {
      title: 'Awards',
    },
    component: () => import(/* webpackChunkName: "awards-index" */ '../views/areas/awards/Index.vue'),
  },
  {
    path: '/awards/create',
    name: 'AwardsCreate',
    meta: {
      title: 'Awards - create new award',
      breadcrumbParent: {
        name: 'Awards',
        text: 'Awards',
      },
    },
    component: () => import(/* webpackChunkName: "users" */ '@/views/areas/awards/Create.vue'),
  },

  {
    path: '/awards/:id',
    name: 'AwardsView',
    meta: {
      title: 'Award - Overview',
      breadcrumbParent: {
        name: 'Awards',
        text: 'Awards',
      },
    },
    component: () => import(/* webpackChunkName: "awards-overview" */ '../views/areas/awards/Overview.vue'),
  },

  {
    path: '/awards/:id/edit',
    name: 'AwardEdit',
    meta: {
      title: 'Awards - edit',
      breadcrumbParent: {
        name: 'AwardsView',
        text: 'Award Overview',
      },
    },
    component: () => import(/* webpackChunkName: "awards-edit" */ '../views/areas/awards/Edit.vue'),
  },

  {
    path: '/awards/:id/restrictions',
    name: 'AwardEditRestrictions',
    meta: {
      title: 'Award - Restrictions',
      breadcrumbParent: {
        name: 'AwardsView',
        text: 'Award Overview',
      },
    },
    component: () => import(/* webpackChunkName: "award-restrictions-index" */ '../views/areas/awards/restrictions/Index.vue'),
  },

  {
    path: '/awards/:id/forms',
    name: 'AwardEditForms',
    meta: {
      title: 'Award - Forms',
      breadcrumbParent: {
        name: 'AwardsView',
        text: 'Award - Overview',
      },
    },
    component: () => import(/* webpackChunkName: "award-forms-index" */ '../views/areas/awards/forms/Index.vue'),
  },

  {
    path: '/awards/:id/nominations/:nomination',
    name: 'NominationsEdit',
    component: () => import(/* webpackChunkName: "nominations-edit" */ '../views/areas/awards/nominations/Edit.vue'),
    meta: {
      title: 'Edit Nomination',
      breadcrumbParent: {
        name: 'AwardsView',
        text: 'Award - Overview',
      },
    },
  },

  {
    path: '/awards/:id/reports/:report',
    name: 'ReportsEdit',
    component: () => import(/* webpackChunkName: "reports-edit" */ '../views/areas/awards/reports/Edit.vue'),
    meta: {
      title: 'Award Report',
      breadcrumbParent: {
        name: 'AwardsView',
        text: 'Award - Overview',
      },
    },
  },

];

export default authRoutesAwards;
